import { serializable, primitive, object, alias } from 'serializr';

class OrganizationLocation {
  @serializable(primitive())
  id?: number;
}

class Address {
  @serializable(primitive())
  city?: string;

  @serializable(primitive())
  street?: string;

  @serializable(primitive())
  province?: string;

  @serializable(alias('postal_code', primitive()))
  postalCode?: string | null;

  @serializable
  country?: string;

  @serializable(alias('country_code', primitive()))
  countryCode?: string;

  @serializable(primitive())
  latitude?: string;

  @serializable(primitive())
  longitude?: string;

  @serializable(alias('province_code'))
  provinceCode?: string;
}

class Location {
  @serializable(primitive())
  name?: string;

  @serializable(primitive())
  category?: string;

  @serializable(object(OrganizationLocation))
  organization?: OrganizationLocation;

  @serializable(object(Address))
  address?: Address;
}

class DataPayload {
  @serializable(object(Location))
  location?: Location;
}

export class CreateLocationPayload {
  @serializable(object(DataPayload))
  data?: DataPayload;
}
